export default __webpack_public_path__ + "static/media/download-arrow.62281b9b.svg";